/**
 * Indexer API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
package indexer.codegen

import kotlinx.serialization.Serializable
import kotlin.js.JsExport

/**
 *
 * @param id
 * @param side
 * @param size
 * @param price
 * @param type
 * @param createdAt
 * @param createdAtHeight
 */
@JsExport
@Serializable
data class IndexerTradeResponseObject(

    val id: kotlin.String? = null,
    val side: IndexerOrderSide? = null,
    val size: kotlin.String? = null,
    val price: kotlin.String? = null,
    val type: IndexerTradeType? = null,
    val createdAt: IndexerIsoString? = null,
    val createdAtHeight: kotlin.String? = null
)
